import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from "react";

import { Warning } from "../styles";

const FiscalWarning: React.FC = () => (
  <Warning>
    <ExclamationCircleOutlined />
    <div>
      <p>
        A <strong>série atual</strong> e o <strong>próximo número</strong> padrão não
        são editáveis. Um <strong>próximo número novo</strong> só é liberado ao
        informar uma <strong>série diferente da padrão</strong>:
      </p>
      <ul>
        <li>
          O próximo número é <strong>por série</strong>: canais com a mesma série
          compartilham o mesmo número (o último valor digitado vale para todos).
        </li>
        <li>
          Confirme que o <strong>próximo número inicial</strong> corresponde ao
          número da próxima nota dessa série — a numeração seguirá a partir dele,
          então revise para evitar conflitos e/ou duplicações.
        </li>
      </ul>
    </div>
  </Warning>
);

export default FiscalWarning;
